export function renderNotFound(root) {
  root.innerHTML = `
    <div class="forensic-page" style="text-align:center">
      <main class="forensic-main">
        <div class="classified-tag">— Case file missing —</div>
        <h1 class="forensic-title">404</h1>
        <p class="forensic-subhead">This investigation appears to have been lost in our archives.<br />Want to start your own?</p>
        <a class="forensic-cta" href="/" style="display:inline-block;text-decoration:none;margin-top:32px">▶ BEGIN YOUR INVESTIGATION</a>
      </main>
    </div>
  `;
}
